import React from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

/**
 * Card de filtros base reutilizável para telas de ocorrências.
 * slots: { antesPeriodo, depoisUsuario, acoesDireita }
 */
const FiltrosOcorrenciasBase = ({
  filtros,
  setFiltros,
  onConsultar,
  onLimpar,
  opcoesGE,
  opcoesEmpreendimento,
  opcoesUsuario,
  loadingLookups,
  usuarioSemGe,
  slots,
}) => {
  const handleChange = (campo, valor) => {
    setFiltros((prev) => ({ ...prev, [campo]: valor }));
  };

  return (
    <Card className="shadow-sm mb-3">
      <Card.Body className="py-2">
        {usuarioSemGe && (
          <div
            className="alert alert-danger py-2 mb-2"
            style={{ fontSize: 13 }}
          >
            Usuário sem Grupo de Empresa autorizado — consultas desabilitadas.
            Contate o administrador.
          </div>
        )}
        {slots && slots.antesPeriodo}
        <Row className="align-items-end mb-2">
          <Col md={3} sm={6} className="mb-2">
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>G.E.</Form.Label>
            <Select
              options={opcoesGE || []}
              value={
                filtros.codigo_grupo_empresa
                  ? (opcoesGE || []).find((o) => o.value === filtros.codigo_grupo_empresa) || null
                  : null
              }
              onChange={(op) => handleChange('codigo_grupo_empresa', op ? op.value : null)}
              isClearable
              placeholder="Todos"
              styles={customStyles}
              components={{ DropdownIndicator }}
              isLoading={loadingLookups}
              isDisabled={usuarioSemGe}
            />
          </Col>
          <Col md={3} sm={6} className="mb-2">
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Empreendimento</Form.Label>
            <Select
              options={opcoesEmpreendimento || []}
              value={
                filtros.codigo_familia
                  ? (opcoesEmpreendimento || []).find((o) => o.value === filtros.codigo_familia) || null
                  : null
              }
              onChange={(op) => handleChange('codigo_familia', op ? op.value : null)}
              isClearable
              placeholder="Todos"
              styles={customStyles}
              components={{ DropdownIndicator }}
              isLoading={loadingLookups}
              isDisabled={usuarioSemGe}
            />
          </Col>
          <Col md={2} sm={6} className="mb-2">
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Período de</Form.Label>
            <Form.Control
              type="date"
              value={filtros.data_ini || ''}
              onChange={(e) => handleChange('data_ini', e.target.value)}
              disabled={usuarioSemGe}
              size="sm"
            />
          </Col>
          <Col md={2} sm={6} className="mb-2">
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>até</Form.Label>
            <Form.Control
              type="date"
              value={filtros.data_fim || ''}
              onChange={(e) => handleChange('data_fim', e.target.value)}
              disabled={usuarioSemGe}
              size="sm"
            />
          </Col>
          <Col md={2} sm={6} className="mb-2">
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Usuário</Form.Label>
            <Select
              options={opcoesUsuario || []}
              value={
                filtros.codigo_usuario_filtro
                  ? (opcoesUsuario || []).find((o) => o.value === filtros.codigo_usuario_filtro) || null
                  : null
              }
              onChange={(op) => handleChange('codigo_usuario_filtro', op ? op.value : null)}
              isClearable
              placeholder="Todos"
              styles={customStyles}
              components={{ DropdownIndicator }}
              isLoading={loadingLookups}
              isDisabled={usuarioSemGe}
            />
          </Col>
        </Row>
        <Row className="align-items-end">
          <Col md={2} sm={6} className="mb-2 d-flex align-items-end">
            <Form.Check
              type="checkbox"
              label="Somente Usuários Ativos"
              checked={filtros.somente_usuarios_ativos !== false}
              onChange={(e) => handleChange('somente_usuarios_ativos', e.target.checked)}
              disabled={usuarioSemGe}
              style={{ fontSize: 12 }}
            />
          </Col>
          {slots && slots.depoisUsuario}
          <Col className="mb-2 d-flex justify-content-end align-items-end" style={{ gap: 6 }}>
            {slots && slots.acoesDireita}
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={onLimpar}
              disabled={usuarioSemGe}
            >
              Limpar Filtros
            </Button>
            <Button
              size="sm"
              variant="primary"
              onClick={onConsultar}
              disabled={usuarioSemGe}
            >
              Consultar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FiltrosOcorrenciasBase;
